<template>
  <div>
    <div style="display: flex; justify-content: flex-end; margin-bottom: 10px">
      <Button @click="addBtn1()">新增</Button>
    </div>
    <Table border ref="selection" :columns="columns" :data="data">
      <template slot-scope="{ row, index }" slot="action">
        <Button icon="md-create" type="warning" size="small" style="margin-right: 8px" @click="editData(row, index)" >编辑</Button >
        <Button icon="md-trash" type="error" size="small" @click="deleteData(row, index)">删除</Button>
      </template>
      <template slot-scope="{ row, index }" slot="action1">
        <Icon type="ios-create" style="font-size: 30px" color="#8CD29B" @click="editBtn1(row, index)"></Icon>
      </template>
      <template slot-scope="{ row, index }" slot="action2">
        <Button size="small" @click="settingBtn(row, index)" :disabled="row.evaType != 3">设定</Button>
      </template>
    </Table>
    <Modal v-model="openAdd1" :title="type == '1' ? '新增' : '编辑'" width="600px">
      <div class="center" style="padding: 0 40px">
        <Form :label-width="170" label-position="left">
          <FormItem label="绩效类型">
            <Select v-model="formItem.achCode" :clearable="true" placeholder="">
              <Option v-for="item in achTypeList" :value="item.code" :key="item.code">{{ item.name }}</Option >
            </Select>
          </FormItem>
          <FormItem label="评价维度">
            <Input v-model="formItem.evaDimension" />
          </FormItem>
          <FormItem label="评价人员设定">
            <Select v-model="formItem.evaType" :clearable="true" placeholder="">
              <Option v-for="item in evaEmpSet" :value="item.code" :key="item.code">{{ item.name1 }}</Option >
            </Select>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="confirmAdd1">确定</Button>
      </div>
    </Modal>

    <!-- 左下 -->
    <div v-show="showEvaluation" style="margin-top: 30px">
      <Table border :columns="columns2" :data="data2">
        <template slot-scope="{ row, index }" slot="action4">
          <Button icon="md-create" type="warning" size="small" style="margin-right: 8px" @click="edit2(row, index)">编辑</Button >
          <Button icon="md-trash" type="error" size="small" @click="delete2(row, index)">删除</Button>
        </template>
      </Table>
      <div style="display: flex; justify-content: flex-end; margin-top: 10px">
        <Button @click="addBtn3()">新增</Button>
      </div>
    </div>
    <Modal v-model="openAdd3" title="新增" width="600px">
      <div class="center" style="padding: 0 40px">
        <Form :label-width="170" label-position="left">
          <FormItem label="评价项目">
            <Input v-model="formItem2.evaProject" />
          </FormItem>
          <FormItem label="评价说明">
            <Input v-model="formItem2.evaExplain" />
          </FormItem>
          <FormItem label="分值定义">
            <Input v-model="formItem2.sorceDefinition" />
          </FormItem>
          <FormItem label="权重">
            <Input v-model="formItem2.weight" />
            <span class="weight-style">%</span>
          </FormItem>
          <FormItem label="得分规则">
            <Input v-model="formItem2.sorceRule" />
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="confirmAdd2">确定</Button>
      </div>
    </Modal>

    <!-- 右上 -->
    <Modal v-model="showPerson" title="设定人员" width="600px">
      <div class="center">
        <Table border :columns="columns1" :data="data1" :loading="prevent" ref="Table" id="Table">
          <template slot-scope="{ row, index }" slot="action3">
            <Button icon="md-create" type="warning" size="small" style="margin-right: 8px" @click="edit1(row, index)">编辑</Button >
            <Button icon="md-trash" type="error" size="small" @click="delete1(row)">删除</Button >
          </template>
        </Table>
        <div style="margin-top:10px">
          <Page :total="total1" @on-change="pageChange1" :disabled="prevent"/>
        </div>
      </div>
      <div slot="footer">
        <Button @click="addBtn2()" :disabled="prevent">新增</Button>
        <Button @click="handelFile" :disabled="prevent">导入</Button>
        <input type="file" ref="uploadExcel" accept=".xlsx,.xls" id="excel-file" @change="importExcel" v-show="false">
      </div>
    </Modal>
    <Modal v-model="editPerson" :title="kpiAction==2 ? '编辑':'新增'" width="600px">
      <Form ref="formItem1" v-model="formItem1" :rules="rules" :model="formItem1" label-position="left" style="padding: 0 40px">
        <FormItem label="被评价人工号" :label-width="120" prop="beEvaId">
          <Input type="text" v-model="formItem1.beEvaId" placeholder="">
            <Button slot="append" icon="ios-search" @click="selectBeEvaId"></Button>
          </Input>
        </FormItem>
        <FormItem label="评价人工号" :label-width="120" prop="evaId">
          <Input type="text" v-model="formItem1.evaId" placeholder="">
            <Button slot="append" icon="ios-search" @click="selectEvaId"></Button>
          </Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="addConfirm()" style="margin-right: 15px">确认</Button>
      </div>
    </Modal>
    <Modal v-model="empoloyee" title="选择员工" width="660px">
      <Form :model="filter" inline :label-width="120" label-position="left">
        <FormItem label="人员姓名">
          <Input type="text" v-model="filter.name" placeholder="" style="width: 150px" :disabled="prevent"></Input>
        </FormItem>
        <Button type="primary" @click="(total = 0), (pageInfo.pageNum = 1), Selection()" :disabled="prevent">查询</Button>
      </Form>
      <Table border :columns="columns4" :data="data4" :loading="prevent">
        <template slot-scope="{ row, index }" slot="action4">
          <Button icon="md-create" type="warning" size="small" style="margin-right: 8px" @click="selectPerson(row, index)" >选择</Button >
        </template>
      </Table>
      <div style="margin-top:10px">
        <Page :total="total" @on-change="pageChange" :disabled="prevent"/>
      </div>
      <div slot="footer">
        <Button type="text" @click="handleCancle" :disabled="prevent">取消</Button>
      </div>
    </Modal>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
  data() {
    return {
      date: new DateUtil(),
      formItem: {},
      formItem1: {},
      formItem2: {},
      columns: [
        {
          title: "绩效类型",
          key: "achCode",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            var name = "";
            this.achTypeList
              ? this.achTypeList.map((item, index) => {
                  if (item.code == params.row.achCode) {
                    name = item.name;
                  }
                })
              : "";
            return h("span", name);
          },
        },
        {
          title: "评价维度",
          key: "evaDimension",
          align: "center",
          minWidth: 120,
        },
        {
          title: "评价人员设定",
          key: "evaType",
          align: "center",
          minWidth: 200,
          render: (h, params) => {
            var name = "";
            this.evaEmpSet
              ? this.evaEmpSet.map((item, index) => {
                  if (item.code == params.row.evaType) {
                    name = item.name1;
                  }
                })
              : "";
            return h("span", name);
          },
        },
        {
          title: "设定人员",
          slot: "action2",
          align: "center",
          minWidth: 120,
        },
        {
          title: "评价项目设定",
          slot: "action1",
          align: "center",
          minWidth: 120,
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 200,
        },
      ],
      data: [],
      // 右上
      columns1: [
        {
          title: "被评价人工号",
          key: "beEvaId",
          align: "center",
          minWidth: 120,
        },
        {
          title: "评价人工号",
          key: "evaId",
          align: "center",
          minWidth: 120,
        },
        {
          title: "操作",
          slot: "action3",
          align: "center",
          minWidth: 200,
        },
      ],
      data1: [],
      columns2: [
        {
          title: "评价项目",
          key: "evaProject",
          align: "center",
          minWidth: 120,
        },
        {
          title: "评价说明",
          key: "evaExplain",
          align: "center",
          minWidth: 120,
        },
        {
          title: "分值定义",
          key: "sorceDefinition",
          align: "center",
          minWidth: 120,
        },
        {
          title: "权重",
          key: "weight",
          align: "center",
          minWidth: 120,
        },
        {
          title: "得分规则",
          key: "sorceRule",
          align: "center",
          minWidth: 120,
        },
        {
          title: "操作",
          slot: "action4",
          align: "center",
          minWidth: 200,
        },
      ],
      data2: [],
      loading: false,
      showEvaluation: false,
      showPerson: false,
      openAdd1: false,
      thisRow: {},
      openAdd3: false,
      evaEmpSet: [],
      achTypeList: [],
      type: 1,
      id: "",
      ActionDetail: false,
      index2: "",
      rowId: "",
      empoloyee: false,
      filter: {},
      columns4: [
        {
          title: "员工工号",
          key: "empCode",
          align: "center",
          minWidth: 120,
        },
        {
          title: "员工姓名",
          key: "userName",
          align: "center",
          minWidth: 120,
        },
        {
          title: "操作",
          slot: "action4",
          minWidth: 120,
          align: "center",
        },
      ],
      data4: [],
      columns5: [],
      data5: [],
      pageInfo: {
        itemCount: 0,
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      pageInfo1: {
        itemCount: 0,
        pageNum: 1,
        pageSize: 10,
      },
      total1: 0,
      editPerson: false,
      selectAction: false,
      kpiAction: "",
      ActionIndex: 1,
      prevent: false,
      personId:'',
      ActionId:'',
      rules: {
        beEvaId: [{ required: true,message: "请选择被评价人工号！"}],
        evaId: [{ required: true,message: "请选择评价人工号！"}]
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      axios.post("/AchEvaSet/selectAchEvaSet", {}).then((res) => {
        this.data = res.achEvaSetList;
        this.evaEmpSet = res.evaEmpSet;
        this.achTypeList = res.achTypeList;
      });
    },
    // 第一个表格
    addBtn1() {
      this.openAdd1 = true;
      this.formItem = {};
      this.type = "1";
    },
    editData(row, index) {
      this.openAdd1 = true;
      this.type = "0";
      this.id = row.id;
      this.thisRow = row;
      this.formItem = {...row};
    },
    deleteData(row, index) {
      this.$Modal.confirm({
        title: this.$notice("deletion"),
        content: "",
        onOk: () => {
          let obj = {
            id: row.id,
          };
          this.loading = true;
          axios.post("/AchEvaSet/deleteAchEvaSet", obj).then((res) => {
            if (res) {
              this.getData();
              setTimeout(()=>{
                this.$Message.success("删除成功");
              },1500)
              this.showEvaluation = false
            }
            this.loading = false;
          });
        },
      });
    },
    confirmAdd1() {
      this.openAdd1 = false;
      // 编辑
      if (this.type == "0") {
        this.$Modal.confirm({
          title: this.$notice("sureSave"),
          content: "",
          onOk: () => {
            this.loading = true;
            let obj = {
              ...this.formItem,
              id: this.id,
              cteateUserId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
            };
            axios.post("/AchEvaSet/updateAchEvaSet", obj).then((res) => {
              this.loading = false;
              if (res) {
                this.getData();
              }
            });
          },
        });
      } else if (this.type == "1") {
        this.loading = true;

        let obj = {
          ...this.formItem,
          cteateUserId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
          updateUserId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
        };
        axios.post("/AchEvaSet/insertAchEvaSet", obj).then((res) => {
          this.loading = false;
          if (res) {
            this.getData();
          }
        });
      }
    },

    //  分解
    editBtn1(row, index) {
      this.rowId = row.id;
      this.showEvaluation = true;
      this.getData2();
    },
    getData2() {
      let obj = {
        id: this.rowId,
      };
      this.loading = true;
      axios
        .post("/AchEvaSetDetails/selectAchEvaSetDetails", obj)
        .then((res) => {
          this.loading = false;
          this.data2 = res;
        });
    },
    // 左下 第三个表格
    edit2(row, index) {
      this.formItem2 = { ...row };
      this.ActionDetail = "2";
      this.indexId = row.id;
      this.openAdd3 = true;
    },
    delete2(row, index) {
      this.$Modal.confirm({
        title: this.$notice("deletion"),
        content: "",
        onOk: () => {
          let obj = {
            id: row.id,
          };
          this.loading = true;
          axios
            .post("/AchEvaSetDetails/deleteAchEvaSetDetails", obj)
            .then((res) => {
              if (res) {
                this.getData2();
                this.$Message.success("删除成功");
              }
              this.loading = false;
            });
        },
      });
    },
    addBtn3() {
      this.openAdd3 = true;
      this.ActionDetail = 1;
      this.formItem2 = {};
      // this.formItem2.targetItemRepeat = this.thisRow.targetItem
      // this.formItem2.contentRepeat = this.thisRow.content
    },
    confirmAdd2() {
      if (this.ActionDetail == "1") {
        this.$Modal.confirm({
          title: this.$notice("sureSave"),
          content: "",
          onOk: () => {
            this.loading = true;
            let obj = {
              ...this.formItem2,
              evaSetId: this.rowId,
              cteateUserId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
              updateUserId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
            };
            axios.post("/AchEvaSetDetails/insertAchEvaSetDetails", obj).then((res) => {
              this.loading = false;
              if (res) {
                this.getData2();
                this.$Message.success("新增成功");
                this.openAdd3 = false;
              }
            });
          },
        });
      } else if (this.ActionDetail == "2") {
        this.$Modal.confirm({
          title: this.$notice("sureSave"),
          content: "",
          onOk: () => {
            this.loading = true;
            let obj = {
              ...this.formItem2,
              id: this.indexId,
              cteateUserId: JSON.parse(sessionStorage.getItem("userInfo"))
                .userId,
            };
            axios.post("/AchEvaSetDetails/updateAchEvaSetDetails", obj).then((res) => {
              this.loading = false;
              if (res) {
                this.$Message.success("编辑成功");
                this.openAdd3 = false;
                this.getData2();
              }
            });
          },
        });
      }
      this.openAdd3 = false;
    },
    
    // 设定
    settingBtn(row, index) {
      this.showPerson = true;
      this.personId = row.id
      this.getPersonId()
    },
    getPersonId(){
      let obj = {
        id: this.personId,
        pageNo: this.pageInfo1.pageNum,
        pageSize: this.pageInfo1.pageSize,
      };
      this.prevent = true
      axios.post("/AchEvaEmpSet/selectAchEvaEmpSet", obj).then((res) => {
        this.prevent = false
        if (res) {
          this.data1 = res.data;
          this.total1 = Number(res.pageInfo.total);
        }
      });
    },
    pageChange1(val){
      this.pageInfo1.pageNum = val;
      this.getPersonId();
    },
    // 右上表格 第二个
    edit1(row, index) {
      this.editPerson = true;
      this.formItem1 = { ...row };
      this.ActionId = row.id;
      this.kpiAction = 2;
      this.$refs['formItem1'].resetFields();
    },
    delete1(row) {
      this.$Modal.confirm({
        title: this.$notice("deletion"),
        content: "",
        onOk: () => {
          let obj = {
            id: row.id,
          };
          this.prevent = true;
          axios.post("/AchEvaEmpSet/deleteAchEvaEmpSet", obj).then((res) => {
            if (res) {
              this.getPersonId()
              this.$Message.success("删除成功");
            }
            this.prevent = false;
          });
        },
      });
    },
    addBtn2() {
      this.editPerson = true;
      this.formItem1 = {};
      this.kpiAction = 1;
      this.$refs['formItem1'].resetFields();
    },
    handelFile() {
      this.$refs.uploadExcel.click();
    },
    importExcel(e) {
      var file_name = document.getElementById('excel-file').value
      file_name = file_name.substring(file_name.lastIndexOf(".")).toLowerCase()
      var uploadFormat = ['.xlsx','.xls']
      if (file_name != uploadFormat[0] && file_name != uploadFormat[1]) {
        this.$Message.warning({
            content: '文件类型不正确, 请选择' + uploadFormat.join(' or ') + '类型',
            duration: 5
        })
        return
      }
      this.prevent = true
      this.$importExcel('excel-file',e,'Table',(data) => {
        this.prevent = false
        // this.count = data.length
        // this.data1 = data
        data.forEach(item => {
          item.evaSetId = this.personId
        });
        axios.post("/AchEvaEmpSet/importAchEvaEmpSet", data).then((res) => {
          this.prevent = false;
          if (res) {
            this.$Message.success('导入成功');
            this.getPersonId()
          }
        });
      })
    },
    Selection() {
      this.prevent = true;
      let obj = {
        userName: this.filter.name,
        pageNo: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        optionName: ["GENDER"],
      };
      axios.post("/Exit/selectEmployeeInfo", obj).then((res) => {
        this.prevent = false;
        this.data4 = res.data;
        this.total = Number(res.pageInfo.total);
      });
    },
    selectBeEvaId() {
      this.empoloyee = true;
      this.Selection();
      this.selectAction = 1;
    },
    selectEvaId() {
      this.empoloyee = true;
      this.Selection();
      this.selectAction = 2;
    },
    pageChange(val) {
      this.pageInfo.pageNum = val;
      this.Selection();
    },
    selectPerson(row, index) {
      if (this.selectAction == 1) {
        this.formItem1.beEvaId = row.empCode;
      } else if (this.selectAction == 2) {
        this.formItem1.evaId = row.empCode;
      }
      this.empoloyee = false;
    },
    addConfirm() {
      this.$refs['formItem1'].validate((valid) => {
        if (valid) {
          this.$Modal.confirm({
            title: this.$notice("sureSave"),
            content: "",
            onOk: () => {
              this.prevent = true
              // 新增
              if (this.kpiAction == 1) {
                let obj = {
                  ...this.formItem1,
                  evaSetId: this.personId,
                };
                axios.post("/AchEvaEmpSet/insertAchEvaEmpSet", obj).then((res) => {
                  this.prevent = false;
                  if (res) {
                    this.getPersonId()
                    this.$Message.success("新增成功");
                  }
                });
                // 编辑
              } else if (this.kpiAction == 2) {
                let obj = {
                  ...this.formItem1,
                  id: this.ActionId,
                };
                axios.post("/AchEvaEmpSet/updateAchEvaEmpSet", obj).then((res) => {
                  this.prevent = false;
                  if (res) {
                    this.getPersonId()
                    this.$Message.success("编辑成功");
                  }
                });
              }
              this.editPerson = false;
            },
            onCancel: () => {
              this.editPerson = false;
            },
          });
        }
      })
    },
    handleCancle() {
      this.empoloyee = false
    },
  },
};
</script>

<style scoped>
.ivu-spin-fix {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 8;
  width: 101% !important;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.9);
}
.weight-style{
  position: absolute;
  top: 0;
  right: 0;
  display: table-cell;
  white-space: nowrap;
  padding: 0 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/process/performanceManagement/QualitativeEvaluationAnd360.vue